import React, {useEffect, useState} from "react";
import {withRouter} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import Header from "./Header/index";
import SideBar from "containers/SideBar/index";
import Footer from "components/Footer";
import Tour from "components/Tour/index";
import {COLLAPSED_DRAWER, FIXED_DRAWER} from "constants/ActionTypes";
import ColorOption from "containers/Customizer/ColorOption";
import {isIOS, isMobile} from "react-device-detect";
import Box from '@material-ui/core/Box';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import RestoreIcon from '@material-ui/icons/Restore';
import FavoriteIcon from '@material-ui/icons/Favorite';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import {useHistory} from 'react-router-dom';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ApartmentIcon from '@material-ui/icons/Apartment';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import Settings from '@material-ui/icons/Settings';
import {switchLanguage, toggleCollapsedNav, changeTitle} from "actions/Setting";

import {useNavigate} from "react-router-dom";


import {Redirect, Route, Switch, useLocation, useParams} from "react-router-dom";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {saveInstallMessage, saveListRserve} from "../../../actions";
import cancell from '../../../assets/images/cancelrequest.png';
import DialogContent from "@material-ui/core/DialogContent";
import share from "../../../assets/images/share.png";
import more from "../../../assets/images/more.png";
import Dialog from "@material-ui/core/Dialog";
// import {toggleCollapsedNav} from "../../../actions";

const Vertical = (props) => {

    const {drawerType} = useSelector(({settings}) => settings);
    const [value, setValue] = React.useState("");
    const dispatch = useDispatch();
    const {navCollapsed} = useSelector(({common}) => common);
    const history = useHistory();
    const {installmessage} = useSelector(({auth}) => auth);
    const [showinstall, setShowinstall] = React.useState(false);
    const [showinstall2, setShowinstall2] = React.useState(false);
    const [iosmodal, setIosmodal] = useState(false)
    const [loader, setLoader] = useState(false);

    const drawerStyle = drawerType.includes(FIXED_DRAWER) ? "fixed-drawer" : drawerType.includes(COLLAPSED_DRAWER) ? "collapsible-drawer" : "mini-drawer";

    //set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
        document.body.classList.add("ios-mobile-view-height");
    } else if (document.body.classList.contains("ios-mobile-view-height")) {
        document.body.classList.remove("ios-mobile-view-height");
    }

    useEffect(() => {

        // if (showinstall !== installmessage) {
        //     setShowinstall(installmessage)
        // }
        // setShowinstall(installmessage)
        // alert(installmessage==='false');
        // console.log(installmessage)


    }, [installmessage]);

    // useEffect(() => {
    //     alert(showinstall);
    // }, [showinstall]);

     const onContactClose = () => {
        setIosmodal(false);
    };


    useEffect(() => {
        // alert(installmessage);
        if (localStorage.getItem('showinstall') === null || localStorage.getItem('showinstall') === '') {
            localStorage.setItem('showinstall', true);
        } else {

        }
        //  setShowinstall(installmessage)
        // console.log(installmessage)

        var delayInMilliseconds = 1000; //1 second

        setTimeout(function () {
            //your code to be executed after 1 second
            // if(!localStorage.getItem('showinstall')){
            //     setShowinstall(false);
            // }
            if(installmessage==='false'){
                setShowinstall(false);
            }
            if(installmessage==='true'){
                setShowinstall(true);
            }




        }, delayInMilliseconds);


    }, []);

    const closemessage = () => {

        dispatch(saveInstallMessage(false));
        setShowinstall(false);
        localStorage.setItem('showinstall', false);

    };

    const goto = (newValue) => {
        setValue(newValue);
        // alert(newValue);
        if (newValue === 2) {

            props.history.push('/app/reserves/list/0')
            // props.push('app/reserves/list/0');
            // history.push('app/reserves/list/0');
        }
        if (newValue === 0) {
            // history.push('app/homepage/list');
            props.history.push('/app/homepage/list')
            // props.push('app/homepage/list');
        }
        if (newValue === 1) {
            // history.push('/app/homes/list');
            props.history.push('/app/homes/list')
            // props.push('/app/homes/list');
        }
        if (newValue === 3) {

            const val = !navCollapsed;
            dispatch(toggleCollapsedNav(val));


        }
    };
    const openInNewTab = url => {
        // alert('ai')
        //  const newWindow  = window.open(url, '_self', 'noopener noreferrer');
        //  if(newWindow) newWindow.opener = null

        window.open(url, '_blank', 'noopener,noreferrer');
        //myFunction(url);
    };

    const firediosinstalled = () => {
        setIosmodal(true);
    };

    return (
        <div className={`app-container ${drawerStyle}`}>
            <Tour/>

            <SideBar/>


            <div className="app-main-container" style={{paddingTop: 60}}>
                {/*<div className="app-header">*/}
                {/*  <Header/>*/}
                {/*</div>*/}

                {/*{showinstall2?*/}
                {/*    <div>ok </div>*/}
                {/*    :*/}
                {/*    <div>no </div>*/}
                {/*}*/}


                {showinstall ?
                    <div style={{

                        display: 'flex',
                        flexDirection: 'column',
                        marginBottom: 10,
                        padding:5,
                        width: '100%'

                    }}>
                        {/*<div style={{ background: '#bbac7d',*/}
                        {/*    display: 'flex', justifyContent: 'space-between',*/}
                        {/*    alignItems: 'center', width: '100%'*/}
                        {/*}}>*/}
                        {/*    <div style={{margin: 10, fontSize: 15, fontFamily: 'iransans'}}>*/}
                        {/*    </div>*/}
                        {/*    */}
                        {/*</div>*/}
                        {/*<div style={{height:10,display: 'flex',background: '#bbac7d', justifyContent: 'space-between',alignItems: 'center', width: '100%'}}>*/}
                        {/*    <div></div>*/}
                        {/*    <img src={cancell} style={{height: 10, width: 10,textAlign:'left'}}/>*/}
                        {/*</div>*/}
                        {/*<img src={cancell} style={{height: 10, width: 10}}/>*/}
                        {/*<div style={{*/}
                        {/*    display: 'flex', height: 10, flexDirection: 'row-reverse', justifyContent: 'space-between',*/}
                        {/*    alignItems: 'center', width: '100%'*/}
                        {/*}}>*/}
                        {/*    <IconButton onClick={closemessage} aria-label="Close">*/}
                        {/*        <CloseIcon/>*/}
                        {/*    </IconButton>*/}
                        {/*</div>*/}


                        {/*<div style={{*/}
                        {/*    height: 10,*/}
                        {/*    display: 'flex',*/}

                        {/*    justifyContent: 'space-between',*/}
                        {/*    alignItems: 'center',*/}
                        {/*    width: '100%'*/}
                        {/*}}>*/}
                        {/*    <div></div>*/}
                        {/*    <img src={cancell} style={{height: 10, width: 10, textAlign: 'left'}}/>*/}
                        {/*</div>*/}




                        <div style={{
                            display: 'flex', justifyContent: 'space-between',
                            height: 50,
                            width: '100%', alignItems: 'center', padding: 5,
                            background: 'rgb(245 226 186)', border: '1px solid #ddd'
                        }}>

                            <div style={{
                                fontSize: 11, marginTop: 5,
                                fontFamily: 'iransans',
                                fontWeight: 'bold',
                            }}>
                                اپلیکیشن همیار میزبان را نصب کنید
                            </div>
                            <div style={{display: 'flex', flexDirection: 'row'}}>


                                <Button variant="contained"
                                        color="primary"
                                        onClick={()=>openInNewTab('https://cafebazaar.ir/app/com.hamyarmizban')}
                                        style={{
                                            width: 35,
                                            height: 25,
                                            marginLeft: 5,
                                            marginTop: 15,
                                            marginBottom: 15,
                                            cursor: 'pointer',
                                            flex: 1,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            border: '1px solid ',
                                            borderColor: '#152e84',
                                            backgroundColor: '#152e84',
                                            borderRadius: 10,
                                        }}
                                        className="iran-font">
                                    <div style={{fontSize: 12, color: '#ffffff', fontWeight: 'bold'}}>اندروید</div>

                                </Button>


                                <Button onClick={firediosinstalled} variant="contained"
                                        color="primary"
                                        style={{
                                            width: 35,
                                            height: 25,
                                            marginLeft: 5,
                                            marginTop: 15,
                                            marginBottom: 15,
                                            cursor: 'pointer',
                                            flex: 1,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            border: '1px solid ',
                                            borderColor: '#152e84',
                                            backgroundColor: '#152e84',
                                            borderRadius: 10,
                                        }}
                                        className="iran-font">
                                    <div style={{fontSize: 12, color: '#ffffff', fontWeight: 'bold'}}>IOS</div>

                                </Button>


                            </div>
                             <img onClick={closemessage} src={cancell} style={{height: 10,alignSelf:'start', width: 10, textAlign: 'left'}}/>
                        </div>
                    </div>


                    :

                    null


                }


                <main className="app-main-content-wrapper">


                    <div className="app-main-content">
                        {props.children}
                    </div>
                    {/*<Footer/>*/}


                    {/*<div   >*/}


                    <Box className="d-lg-none" style={{position: 'fixed', bottom: 0, left: 0, right: 0}} elevation={3}>
                        <BottomNavigation
                            showLabels
                            value={value}
                            onChange={(event, newValue) => {
                                goto(newValue);
                            }}
                        >
                            <BottomNavigationAction
                                label={<span
                                    style={{fontFamily: 'IRANSans', fontWeight: 'bold', fontSize: 10}}>داشبورد</span>}
                                icon={<DashboardIcon/>}/>
                            <BottomNavigationAction
                                label={<span
                                    style={{fontFamily: 'IRANSans', fontWeight: 'bold', fontSize: 10}}>اقامتگاه</span>}
                                icon={<ApartmentIcon/>}/>
                            <BottomNavigationAction label={<span
                                style={{fontFamily: 'IRANSans', fontWeight: 'bold', fontSize: 10}}>رزرو ها</span>}
                                                    icon={<MonetizationOnIcon/>}/>
                            <BottomNavigationAction label={<span
                                style={{fontFamily: 'IRANSans', fontWeight: 'bold', fontSize: 10}}>امکانات</span>}
                                                    icon={<Settings/>}/>


                        </BottomNavigation>
                    </Box>

                    {/*</div>*/}


                </main>




            </div>
            <ColorOption/>

            <Dialog open={iosmodal} PaperProps={{
                style: {margin: 0}
            }} onClose={onContactClose} className="slideInUpTiny">
                {/*<DialogTitle>*/}
                {/*<div style={{fontFamily: 'iransans'}}>*/}
                {/*ثبت مخاطب جدید*/}
                {/*</div>*/}

                {/*</DialogTitle>*/}

                <div style={{
                    display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', width: '100%'
                }}>

                    <div style={{margin: 10, fontSize: 15, fontFamily: 'iransans'}}>
                        نصب نسخه وب اپلیکیشن
                    </div>

                    <IconButton onClick={onContactClose} aria-label="Close">
                        <CloseIcon/>
                    </IconButton>


                </div>


                <DialogContent>
                    <div style={{
                        display: 'flex', justifyContent: 'start', flex: 1,
                        alignItems: 'start', flexDirection: 'column', width: 270,
                    }}>


                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginBottom: 15,
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <img src={share} style={{width: 25, height: 25}}></img>
                            <div style={{
                                fontFamily: 'iransans',
                                marginRight: 5,
                                fontWeight: 'bold',
                                fontSize: 13
                            }}>۱.در نوار پایین دکمه Share را بزنید.
                            </div>

                        </div>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginBottom: 15,
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <img src={more} style={{width: 25, height: 25}}></img>
                            <div style={{
                                fontFamily: 'iransans',
                                marginRight: 5,
                                fontWeight: 'bold',
                                fontSize: 13
                            }}>۲.دکمه Add to Home Screen را انتخاب کنید.
                            </div>

                        </div>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginBottom: 15,
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <div style={{fontWeight: 'bold', fontSize: 14}}>Add</div>
                            <div style={{
                                fontFamily: 'iransans',
                                marginRight: 5,
                                fontWeight: 'bold',
                                fontSize: 13
                            }}>۳.در مرحله اخر روی دکمه Add بزنید.
                            </div>

                        </div>


                        <div className="d-flex align-items-center" style={{width: '100%'}}>

                            <Button onClick={onContactClose} disabled={loader} variant="contained"

                                    style={{
                                        width: '100%',
                                        height: 40,
                                        backgroundColor: '#3f51b5',
                                        marginTop: 15,
                                        marginBottom: 15,
                                        flex: 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        border: '1px solid ',
                                    }}
                                    className="iran-font">
                                <div style={{fontSize: 15, color: '#fff', fontWeight: 500}}>متوجه شدم</div>

                            </Button>


                        </div>


                    </div>


                </DialogContent>


            </Dialog>


        </div>
    );
};

export default withRouter(Vertical);
